// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1165":"123e1f27","2525":"98f29caa","3690":"0089643e","4178":"98f29caa","5848":"9063d85e","6109":"b1ec060b","8899":"9063d85e"}[chunkId] + ".chunk.css";
};